const baseTableSlot = [
  { // 序号
    slot: 'subscript',
    component: 'Subscript'
  },
  { // 颜色标签
    slot: 'color',
    component: 'Color'
  },
  { // 操作栏
    slot: 'action',
    component: 'Action',
    list: [
      { name: '发布', cb: 'issue', divider: false },
      { name: '删除', cb: 'delete', divider: true }
    ]
  }
]

module.exports = {
  baseTableSlot
}